import React, { forwardRef, useImperativeHandle, useState } from 'react';

const NumericEditor = forwardRef((props, ref) => {
    const [value, setValue] = useState(props.value);

    const onChange = (event) => {
        const newValue = event.target.value;
        // Check if the new value is numeric
        if (!isNaN(newValue)) {
            setValue(newValue);
        }
    };

    // Expose getValue method to the parent component
    useImperativeHandle(ref, () => ({
        getValue() {
            return value;
        }
    }));

    return <input type="text" value={value} onChange={onChange} />;
});

export default NumericEditor;
